import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SEO from "@/components/SEO";
import { Reveal, SectionHeading } from "@/components/Reveal";
import Marquee from "@/components/Marquee";
import CtaBand from "./home/CtaBand";
import api from "@/lib/api";
import { FALLBACK_SERVICES } from "@/lib/constants";

export default function Services() {
  const [services, setServices] = useState(FALLBACK_SERVICES);
  useEffect(() => {
    api.get("/services").then(({ data }) => data?.length && setServices(data)).catch(() => {});
  }, []);

  return (
    <>
      <SEO
        title="Servicii — construcții, renovări, instalații, exterior, energie | BROX CONSTRUCT"
        description="Șase linii de servicii, un singur punct de contact: construcții, renovări și interioare, instalații, exterior, energie și lucrări speciale."
        path="/servicii"
      />
      <section className="grain relative overflow-hidden bg-ink-950 pb-10 pt-28 sm:pb-24 sm:pt-40">
        <div className="container-brox">
          <Reveal><p className="eyebrow mb-5">SERVICII</p></Reveal>
          <Reveal delay={0.08}>
            <h1 className="display-title text-5xl sm:text-7xl" data-testid="services-page-title">
              Șase linii de servicii.<br /><span className="text-copper">Un singur contact.</span>
            </h1>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-muted-foreground sm:text-lg">
              Fiecare categorie este executată de echipa potrivită, în funcție de specificul proiectului —
              prin echipele noastre sau prin firme partenere selectate.
            </p>
          </Reveal>
        </div>
      </section>

      <Marquee />

      <section className="bg-ink-950 py-12 sm:py-24" data-testid="services-list-section">
        <div className="container-brox space-y-5">
          {services.map((svc, i) => (
            <Reveal key={svc.slug}>
              <Link
                to={`/servicii/${svc.slug}`}
                className="card-brox group grid gap-0 overflow-hidden lg:grid-cols-12 hover:border-copper/50"
                data-testid={`service-row-${svc.slug}`}
              >
                <div className="relative h-40 lg:col-span-4 lg:h-auto lg:min-h-[220px]">
                  <img src={svc.hero_image} alt={`${svc.title} — Brox Construct`} loading="lazy"
                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <span className="absolute left-5 top-5 font-mono text-xs text-copper">0{i + 1}</span>
                </div>
                <div className="flex flex-col justify-center gap-4 p-5 sm:p-10 lg:col-span-8">
                  <div className="flex items-start justify-between gap-6">
                    <div>
                      <h2 className="display-title text-3xl sm:text-4xl">{svc.title}</h2>
                      <p className="mt-2 text-sm text-copper sm:text-base">{svc.tagline}</p>
                    </div>
                    <span className="hidden h-12 w-12 shrink-0 items-center justify-center border border-white/15 text-paper transition-all duration-300 group-hover:border-copper group-hover:bg-copper group-hover:text-ink-950 sm:flex">
                      <ArrowUpRight className="h-5 w-5" />
                    </span>
                  </div>
                  <p className="text-sm leading-relaxed text-muted-foreground">{svc.intro}</p>
                  <div className="flex flex-wrap gap-1.5">
                    {svc.items.map((item) => (
                      <span key={item} className="border border-white/10 bg-ink-900 px-2.5 py-1 font-mono text-[10px] uppercase tracking-wider text-paper/60">
                        {item}
                      </span>
                    ))}
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <CtaBand />
    </>
  );
}
